module.exports = __webpack_public_path__ + "static/media/france.561d8c4f.svg";